import React, { useState, useEffect, useLayoutEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import styles from './ArtistDetail.module.css';

import MusicDetailLoading from "../../../components/skeletonLoading/detailLoading/MusicDetailLoading";
import { useFetchDetailDataQuery } from "../../../api/homepageApi";
import { useParams } from "react-router";
import { useNavbar } from "../../../context/NavBarContext";

import CategorySeeAllButton from "../../../components/reusable/categorySeeAll/CategorySeeAll";

//icons
import { IoChevronBack } from "react-icons/io5";

import { NotFound } from "../../error/NotFound_404";

const ArtistDetail = () => {
  const navigate = useNavigate();
  const [isInitialMount, setIsInitialMount] = useState(true);
  const [options, setOptions] = useState({
    url: "",
    body: {},
  });

  const { data, error, isLoading, isFetching } = useFetchDetailDataQuery(options, {
    skip: isInitialMount,
  });

  const Navbar = useNavbar();
  const { id } = useParams();

  useEffect(() => {
    const updateOptions = () => {
      setOptions(() => ({
        url: `/music/artist/detail`,
        body: {
          'artist_id': id,
        },
      }));
    };

    updateOptions();
    setIsInitialMount(false);
    // Navbar.setLogoPlace(data.result.title);
   
  }, []);

  useLayoutEffect(() => {
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  },[])

  if(isLoading) {
    return <MusicDetailLoading />
  }

  if (error) {
    return <NotFound error={error} />
  }

  const handleDetail = (song_id) => {
    navigate(`/music/detail/songs/${song_id}`, {state :{type: 'one'}});
  };

  const handleClickAlbum = (albumId) => {
    navigate(`/music/detail/album/${albumId}`);
  }


  return (
    <div className="mt-3">
      <div className="rounded-lg">
        <img
          src={data?.result.artist_image}
          alt="image"
          className={`${styles.artist_image} rounded-lg`}
        />
      </div>
      {data?.result.album.length > 0 && (
        <div className="mt-4 block">
          <Box className="flex justify-center">
            <Typography variant="h6" className="inline-block" fontWeight={600}>
              Album
            </Typography>
            <CategorySeeAllButton to={`/music/artist/${id}/albums`} />
            {/* <Link
                to={`/music/artist/${id}/albums`}
              className="float-right text-yellow-400"
            >
              See All
            </Link> */}
          </Box>
          <Box marginTop={4} className={`${styles.imageContainer}`}>
            {data?.result.album.map((item, index) => (
              <div
                className={`${index === data.length - 1 ? "" : "mr-4"} ${
                  styles.scrollableImage
                }`}
                key={index}
                onClick={() => handleClickAlbum(item.album_id)}
              >
                <img
                  src={item.album_image}
                  key={index}
                  alt={`Image ${index + 1}`}
                  className={`${styles.image} rounded-lg`}
                />
                <span className="block text-sm mt-2 truncate">
                  {item.album_title}
                </span>
                <span className="block text-xs mt-2 truncate">{item.album_artist}</span>
              </div>
            ))}
          </Box>
        </div>
      )}
      {data?.result.song.length > 0 && (
        <div className={`mt-4`}>
          <Box className="flex justify-center">
            <Typography variant="h6" className="inline-block" fontWeight={600}>
              Songs
            </Typography>
            <CategorySeeAllButton to={`/music/artist/${id}/songs`} />
            {/* <Link
                to={`/music/artist/${id}/songs`}
              className="float-right text-yellow-400"
            >
              See All
            </Link> */}
          </Box>
          <Box marginTop={4} className="grid grid-cols-2 gap-4">
            {data.result.song.map((item, index) => (
              <Box key={index} className="flex" onClick={() => handleDetail(item.song_id)}>
                <div className="w-1/4 inline-block">
                  <img
                    src={item.song_image}
                    alt={`Image ${index + 1}`}
                    className={`rounded-lg`}
                  />
                </div>
                <div className="w-2/4 flex items-center justify-center">
                  <div className="w-full ml-4">
                    <span className="block text-sm truncate">
                      {item.song_title}
                    </span>
                    <span className="block text-xs py-1 truncate">
                      {item.song_artist}
                    </span>
                  </div>
                </div>
              </Box>
            ))}
          </Box>
        </div>
      )}
    </div>
  );
};

export default ArtistDetail;
